import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { BenefitsTags } from './components/BenefitsTags';
import { BonusesSection } from './components/BonusesSection';
import { MercadoPagoBadge } from './components/MercadoPagoBadge';
import { CheckoutSection } from './components/CheckoutSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
const META_PIXEL_ID = '1927478928649366';
export function App() {
  useEffect(() => {
    // Evitar duplicados (React StrictMode double mount)
    if (window.fbq) return;
    // Inyectar el snippet oficial de Meta Pixel como inline script
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.insertBefore(inlineScript, document.head.firstChild);
    // Marcar como cargado para evitar duplicados
    window.fbq = (window as any).fbq;
    // Noscript fallback
    if (!document.querySelector('img[src*="facebook.com/tr"]')) {
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
      document.body.appendChild(img);
    }
  }, []);
  return <div className="min-h-screen bg-brand-black text-brand-text font-body antialiased pt-10" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofPopup data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <SalesLetter data-id="element-5" />
        <BenefitsTags data-id="element-6" />
        <BonusesSection data-id="element-7" />
        <MercadoPagoBadge data-id="element-8" />
        <CheckoutSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>
    </div>;
}